import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
type Status = 'idle' | 'error' | 'sending' | 'done';
export function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<Status>('idle');
  function submit(event: React.FormEvent) {
    event.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) {
      setStatus('error');
      return;
    }
    setStatus('sending');
    window.setTimeout(() => setStatus('done'), 600);
  }
  if (status === 'done') {
    return <p role="status" className="mt-6 inline-flex items-center gap-2 rounded-[15px] bg-white/10 px-4 py-3 type-card-desc text-white" data-id="element-673" data-mp="3mep7j2mybfqa">
        <CheckIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-674" data-mp="3w51rasmxz4vd" />
        Thanks — you're subscribed.
      </p>;
  }
  return <form onSubmit={submit} noValidate className="mt-6 max-w-md" aria-label="Subscribe to our newsletter" data-id="element-675" data-mp="e0gp2ne585bu">
      <div className="flex items-center rounded-[15px] bg-white p-1.5 focus-within:ring-2 focus-within:ring-brand" data-id="element-676" data-mp="91n8un7h207z">
        <label htmlFor="footer-email" className="sr-only" data-id="element-677" data-mp="2rukalek71rxr">
          Email
        </label>
        <input id="footer-email" type="email" value={email} onChange={e => {
        setEmail(e.target.value);
        if (status === 'error') setStatus('idle');
      }} placeholder="Email" aria-invalid={status === 'error'} aria-describedby={status === 'error' ? 'footer-email-error' : undefined} className="min-w-0 flex-1 bg-transparent px-3 type-field text-ink placeholder:text-muted focus:outline-none" data-id="element-678" data-mp="2wscd12igswg7" />
        <button type="submit" disabled={status === 'sending'} className="h-11 shrink-0 rounded-[12px] bg-brand px-5 type-button font-bold text-white transition-colors duration-150 hover:bg-brand-hover active:bg-brand-press disabled:cursor-wait" data-id="element-679" data-mp="3ki6nxej84axt">
          {status === 'sending' ? 'Sending…' : 'Subscribe'}
        </button>
      </div>
      {status === 'error' ? <p id="footer-email-error" className="mt-2 type-small font-semibold text-white" data-id="element-680" data-mp="1zabp559m2diz">
          Please enter a valid email address.
        </p> : null}
    </form>;
}